import { useCallback, useEffect, useState } from "react";
import { listarContasFinanceirasFinanceiro } from "../services/contas-financeiras-financeiro.service";
import type { ContaFinanceiraFiltroApi } from "../types/extrato-financeiro.types";

export type UseContasFinanceirasFinanceiroResult = {
  data: ContaFinanceiraFiltroApi[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
};

export function useContasFinanceirasFinanceiro(): UseContasFinanceirasFinanceiroResult {
  const [data, setData] = useState<ContaFinanceiraFiltroApi[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data: rows, status } = await listarContasFinanceirasFinanceiro();
        if (cancelled) return;
        if (status !== 200 || !rows) {
          setError("Não foi possível carregar contas financeiras.");
          setData([]);
          return;
        }
        setData(rows);
      } catch (e: unknown) {
        if (cancelled) return;
        const msg =
          e instanceof Error ? e.message : "Falha ao carregar contas financeiras.";
        setError(msg);
        setData([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    void run();
    return () => {
      cancelled = true;
    };
  }, [tick]);

  const refetch = useCallback(() => {
    setTick((n) => n + 1);
  }, []);

  return { data, loading, error, refetch };
}
